import { schemas } from '@weenat/client'
import { PhoneType } from '@weenat/client/dist/resources/me'
import { useIntl } from '@weenat/wintl'
import Button, { ButtonProps } from 'app/src/kit/Button'
import CheckboxField from 'app/src/kit/fields/CheckboxField'
import TelephoneFields from 'app/src/kit/fields/TelephoneFields'
import SubmitButton from 'app/src/kit/SubmitButton'
import SuperForm from 'app/src/kit/SuperForm'
import Text from 'app/src/kit/Text'
import { styled } from 'styled-components'

const SINGLE_PHONE_SCHEMA = schemas.me.newPhoneNumber
export type SinglePhoneFormValues = typeof SINGLE_PHONE_SCHEMA.initialValues

const ADD_PHONE_INITIAL_VALUES: SinglePhoneFormValues = {
  enabled: false,
  telephoneCountryCode: 'FR',
  telephoneNumber: ''
}

const AddPhoneFormContainer = styled(Box)`
  width: 100%;
  border-radius: ${(p) => p.theme.radiuses.md}px;
  margin-top: ${(p) => p.theme.spacings.md}px;
  padding: ${(p) => p.theme.spacings.lg}px;
  border: 1px solid ${(p) => p.theme.colors.grayscale[300]};
  background-color: ${(p) => p.theme.colors.grayscale[100]};
`

interface AddPhoneFormProps {
  phoneType: Exclude<PhoneType, 'none'>
  onSubmit: (values: SinglePhoneFormValues) => void
  onCancel: () => void
  buttonState: ButtonProps['state']
}

const AddPhoneForm: FC<AddPhoneFormProps> = ({ phoneType, onSubmit, onCancel, buttonState }) => {
  const { t } = useIntl()

  return (
    <AddPhoneFormContainer>
      <Text $fontWeight='bold' $mb='md'>
        {t(
          phoneType === 'primary'
            ? 'user_settings.phone_numbers.add_primary_phone'
            : 'user_settings.phone_numbers.add_secondary_phone',
          { capitalize: true }
        )}
      </Text>
      <SuperForm
        schema={SINGLE_PHONE_SCHEMA}
        onSubmit={onSubmit}
        initialValues={ADD_PHONE_INITIAL_VALUES}
      >
        <TelephoneFields hideLabel isLoading={buttonState?.isPending} />
        <Box $mt='md'>
          <CheckboxField
            label={t('user_settings.phone_numbers.activate_number_by_default')}
            name='enabled'
          />
        </Box>
        <Flex $width='100%' $justifyContent='flex-end' $gap='md' $mt='md'>
          <Button
            color={'grayscale.black'}
            backgroundColor={'transparent'}
            variant='compact'
            importance='sd'
            onPress={onCancel}
          >
            {t('actions.cancel')}
          </Button>
          <SubmitButton backgroundColor={'grayscale.black'} variant='compact' state={buttonState} />
        </Flex>
      </SuperForm>
    </AddPhoneFormContainer>
  )
}

export default AddPhoneForm
